import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TenantData } from "system/types/wireTypes";

interface IntuneState {
  isIntuneOn: boolean;
  selectedTenant: TenantData | null;
}

const intuneState: IntuneState = {
  isIntuneOn: false,
  selectedTenant: null,
};

const intuneReducers = {
  setIntuneOn(state: IntuneState, action: PayloadAction<boolean>) {
    state.isIntuneOn = action.payload;
  },
  setSelectedTenant(state: IntuneState, action: PayloadAction<TenantData | null>) {
    state.selectedTenant = action.payload;
  },
};

const intuneSlice = createSlice({
  name: "intune",
  initialState: intuneState,
  reducers: intuneReducers,
});

export const intuneActions = intuneSlice.actions;
export default intuneSlice;
